import { InferType, object, string } from 'yup'
import { EMAIL_REGEX } from '@/utils'

export const footerSocialValidationSchema = object({
  email: string()
    .matches(EMAIL_REGEX, 'Please enter valid email address.')
    .required('Please enter email id.'),
})

export type FooterSocialFormValues = InferType<typeof footerSocialValidationSchema>

export const footerSocialFormInitValues: FooterSocialFormValues = {
  email: '',
}
